import Actions                           from 'Redux/Actions';
import { EventParentCategoryRepository } from 'Domain/Repositories';
import { ofType }                        from 'redux-observable';
import { from }                          from 'rxjs';
import { mergeMap }                      from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';

export const searchEventParentCategoriesEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.searchEventParentCategoriesRequest.type),
    mergeMap(action => from(
      EventParentCategoryRepository.findAll(action.payload)
        .then(({ eventParentCategories, meta }) => Actions.searchEventParentCategoriesSuccess({ eventParentCategories, maxCount: meta?.count }))
        .catch((error: Error) => Actions.searchEventParentCategoriesFailure({ error })),
    )),
  );
};
